/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Blood Pressure View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';
// View
import View from './BloodPressureView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsBloodPressure = mapStateToProps;
export const mapDispatchToPropsBloodPressure = mapDispatchToProps;

export default connect(
  mapStateToPropsBloodPressure,
  mapDispatchToPropsBloodPressure
)(View);
